module.exports = __webpack_public_path__ + "static/lovelyhappynews-ba86ad204fb95e87a46801c7516949ed.jpeg";